import React from 'react';
import { Route, Redirect } from "react-router-dom";

const GuardedRoute = ({ component: Component, auth, ...rest }) => (
    <Route {...rest} render={(props) => (
        auth === true
            ? <Component {...props} />
            : <Redirect to={`/app/account/login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`} />
    )} />
)

export default GuardedRoute;